import axios from 'axios';
import { get } from './http-client';

export default {
  obtenerAgenciaDerivacion: (datos) => {
    return get(
      `${process.env.RAZZLE_GATEWAY_MUNDIGEA}/agencia/derivacion?
        provinciaId=${datos.provinciaId}&
        localidadId=${datos.localidadId}&
        aplicacionId=${datos.appId}&
        tipoAccion=${datos.tipoAccion}`,
    )
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return false;
      });
  },
  confirmarDerivacion: ({ defaultGroup, aplicacionId, tipoAccion }) => {
    const data = { defaultGroup, aplicacionId, tipoAccion };
    return axios
      .post(`${process.env.RAZZLE_GATEWAY_MUNDIGEA}/agencia/confirmar-accion`, data, {
        headers: {
          'Content-type': 'application/json',
          Accept: '*/*',
          'Accept-Encoding': 'gzip, deflate, br',
        },
      })
      .then((res) => res.data)
      .catch((err) => {
        s;
        console.error(err);
        return false;
      });
  },
};
